/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, December 6th 2022, 9:54:57 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

/**
 *
 * Utility function that gets environment variables. Due to the custom way we are setting environment variables
 * in our docker file, this function automatically sets the requested environment variable to undefined if the
 * variable value is the same as the variable name e.g. REACT_APP_SOME_VAR=REACT_APP_SOME_VAR
 * (See how we are setting environment variables in Dockerfile).
 *
 * @param variableName
 * @returns string | undefined
 */

export const getEnv = (variableName: string) => {
  if (process.env[variableName] === `TMP_VALUE_${variableName}`) return undefined;

  return process.env[variableName];
};
